import React, { Component } from 'react'
import { graphql } from 'gatsby'

import layoutQuery from "../hooks/use-layout-query"

import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import Link from '../utils/link'
import parse from 'html-react-parser'
import Seo from '../components/seo'
import { Arrow, Close } from '../components/icons'
import Slider from "react-slick"
import Vimeo from '@u-wave/react-vimeo';
import Fade from 'react-reveal/Fade'

import FsLightbox from 'fslightbox-react'

// import Protected from '../components/password-protected'

class PostTemplate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isClicked: false,
      currentSlide: 1,
      totalSlides: 0,
      showInfo: false,
      autoplay: true,
      // Calc slider height
      maxSlideHeight: 0,
      imagesLoaded: 0,
      totalImages: 0,
      isSliderLoaded: false,
      // VIDEO
      videoIndex: 0,
      volume: 0,
      paused: Array(props.data.wpProject.acf.gallery.length).fill(false),
      isActive: false,
      isVolumeActive: false,
      // Password protected
      username: '',
      password: '',
      showContent: false,
      showMessage: false,
      imageLightbox: false,
      showNextProject: false,
    };
    this.resizeTimer = null;
    this.sliderRef = React.createRef();
    // VIDEO
    this.handlePause = this.handlePause.bind(this);
    // this.handlePlayerPause = this.handlePlayerPause.bind(this);
    // this.handlePlayerPlay = this.handlePlayerPlay.bind(this);
    this.handleVolume = this.handleVolume.bind(this);

    this.handleScroll = this.handleScroll.bind(this);

  }

  // START  – Password Protected

  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
      showMessage: false, // Hide the message when the user starts typing again
    });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const { username, password } = this.state;
  
    const { wpProject } = this.props.data;
    const { wp } = this.props.data;

    // console.log("WP Options:", wp.siteOptions.users);
  
    // Check if projects data is available
    if (!wpProject) {
      console.error('Projects data is not available.');
      return;
    }  
    

    if (!wpProject.acf.passwordProtected) {


      // Project not password protected, show content directly
      this.setState({
        showContent: true,
        showMessage: false,
      });

      this.calculateMaxSlideHeight();

      return;
    }
    
    const users = wp.siteOptions.acf?.users;
    //const users = wpProject.acf.users;
    
    const user = users.find((user) => user.username === username && user.password === password);
  
    if (user) {
      this.setState({
        showContent: true,
        showMessage: false,
      });

      this.calculateMaxSlideHeight();
      
    } else {
      this.setState({
        showMessage: true,
      });
    }
  };
  // END – Password Protected




  play = () => {
    this.sliderRef.current.slickPlay();
  };

  pause = () => {
    this.sliderRef.current.slickPause();
  };

  handleClick = () => {
    this.setState(prevState => ({
      isClicked: !prevState.isClicked,
      showInfo: !prevState.showInfo,
    }));

    if (this.state.showInfo === false) {
      this.sliderRef.current.slickPause();
    }

    if (this.state.showInfo === true) {
      this.sliderRef.current.slickPlay();
    }
  };

  getButtonText() {
    return this.state.isClicked ? 'Project Images' : 'Project Text';
  }

  componentDidMount() {
    const { wpProject } = this.props.data;
    if (wpProject && wpProject.acf && wpProject.acf.gallery) {
      this.setState({ totalSlides: wpProject.acf.gallery.length });
    }

     // Check if the first slide is a video and set autoplay state
     if (wpProject.acf.gallery[0].layoutType === 'video') {
      this.setState({ paused: false });
    }

    // START - Calc slider height
    const totalImages = wpProject.acf.gallery.length;

    this.setState({ totalImages }, () => {
      this.calculateMaxSlideHeight();
    });
    window.addEventListener('resize', this.calculateMaxSlideHeight);
    // END - Calc slider height
  }

  // START - Calc slider height
  componentWillUnmount() {
    window.removeEventListener('resize', this.calculateMaxSlideHeight);
  }

  handleImageLoad = () => {
    this.setState(prevState => ({
      imagesLoaded: prevState.imagesLoaded + 1,
    }), () => {
      if (this.state.imagesLoaded === this.state.totalImages) {
        this.calculateMaxSlideHeight();
      }
    });
  };

  calculateMaxSlideHeight = () => {
    if (this.resizeTimer) {
      clearTimeout(this.resizeTimer);
    }
  
    this.resizeTimer = setTimeout(() => {
      const slideItems = document.getElementsByClassName('slider__inner');
  
      // Reset the height of slide items to auto to calculate the actual image height
      for (let i = 0; i < slideItems.length; i++) {
        const slideItem = slideItems[i];
        slideItem.style.height = 'auto';
      }
  
      let maxHeight = 400; // Set a default height of 400px
      let firstLandscapeImageHeight = 0;
  
      if (slideItems.length > 0) {
        for (let i = 0; i < slideItems.length; i++) {
          const slideItem = slideItems[i];
          const image = slideItem.querySelector('img');
          if (image && image.width > image.height) {
            firstLandscapeImageHeight = image.offsetHeight;
            break;
          }
        }
      }

      if (firstLandscapeImageHeight > 0) {
        // If there is a landscape image, set maxHeight to the maximum of firstLandscapeImageHeight and 400px
        maxHeight = Math.max(firstLandscapeImageHeight, 400);
      }
  
      // Set the maxHeight value as the height for all slide items
      for (let i = 0; i < slideItems.length; i++) {
        const slideItem = slideItems[i];
        slideItem.style.height = `${maxHeight}px`;
      }
  
      // Update the maxSlideHeight state with the new maxHeight value
      this.setState({ maxSlideHeight: maxHeight, isSliderLoaded: true });
    }, 190); // Adjust the timeout duration as needed (e.g., 300ms)
  };


  //
  // Scroll
  componentDidMount() {
    // Add scroll event listener when the component mounts
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    // Remove scroll event listener when the component unmounts
    window.removeEventListener('scroll', this.handleScroll);
  }

  // handleScroll() {
  //   // Calculate the scroll position
  //   const scrollPosition = window.scrollY;

  //   // Check if the scroll position is greater than or equal to 100vh
  //   if (scrollPosition >= window.innerHeight -700) {
  //     // Update the state to show the next project
  //     this.setState({ showNextProject: true });
  //   } else {
  //     // Update the state to hide the next project
  //     this.setState({ showNextProject: false });
  //   }
  // }
  
  handleScroll() {
    const scrollPosition = window.scrollY;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;

    if (scrollPosition >= windowHeight && scrollPosition < documentHeight - windowHeight) {
      this.setState({ showNextProject: true });
    } else {
      this.setState({ showNextProject: false });
    }
  }
  

  // END - Calc slider height


  // Video start
  handlePause(event) {
    this.setState({
      paused: event.target.checked,
    });
    this.setState({ isActive: !this.state.isActive });
  }

  // handlePlayerPause() {
  //   this.setState({ paused: true });
  // }

  // handlePlayerPlay() {
  //   this.setState({ paused: false });
  // }

  handleVolume(volume) {
    if(this.state.volume === 1) {
      this.setState({ volume: 0 });
    } else {
      this.setState({ volume: 1 });
    }
    this.setState({ isVolumeActive: !this.state.isVolumeActive });
  }

  selectVideo(index) {
    this.setState({ videoIndex: index });
  }


  // Helper methods
  playVideo() {
    this.setState({ paused: false });
    // console.log('make video play');
  }

  pauseVideo() {
    this.setState({ paused: true });
    // console.log('make video pause');
  }
  // Video End

  render() {
    const { username, password, showContent, showMessage, imageLightbox } = this.state;

    const passProtected = this.props.data.wpProject.acf.passwordProtected;

    let { imageSlider } = this.props.data.wpProject.acf.gallery;
    const { wpProject } = this.props.data;
    const { next } = this.props.pageContext;
    const { prev } = this.props.pageContext;
    const { currentSlide, totalSlides, showInfo } = this.state;

    const { showNextProject } = this.state;

    // START - Calc slider height
    const { maxSlideHeight } = this.state;
    // END - Calc slider height

    const settings = {
      pauseOnHover: false,
      fade: false,
      speed: 600,
      autoplaySpeed: 6000,
      infinite: true,
      slidesToShow: 1,
      arrows: true,
      dots: false,
      autoplay: this.state.autoplay,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            infinite: true,
            arrows: false,
            slidesToShow: 1,
          }
        },
        {
          breakpoint: 480,
          settings: {
            infinite: true,
            arrows: false,
            slidesToShow: 1
          }
        }
      ],
      afterChange: (index) => {
        this.setState({ currentSlide: index + 1 });

        // Check if the current slide is a video
        const { wpProject } = this.props.data;
        const currentSlide = wpProject.acf.gallery[index];
        if (currentSlide.layoutType === 'video') {
          this.sliderRef.current.slickPause(); // Pause autoplay for video slide
          this.setState({ paused: false });
        } else {
          // this.pauseVideo();
          this.sliderRef.current.slickPlay(); // Resume autoplay for non-video slide
        }
      },

      beforeChange: (current, next) => {
        // Check if the current slide is a video
        const { wpProject } = this.props.data;
        const currentSlide = wpProject.acf.gallery[current];
         if (currentSlide.layoutType === 'video') {
          this.sliderRef.current.slickPause(); // Pause autoplay for video slide
        } else {
          this.sliderRef.current.slickPlay(); // Resume autoplay for non-video slide
        }
      },
      afterSlide: () => {
        // No changes here
      }
    };



    const images = wpProject.acf.gallery?.map((el, idx) => {
      if (el.layoutType === 'landscape') {
        return {
          key: idx,
          src: el.landscapeImage?.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
          className: 'property-single__lightbox-image',
        };
      } else if (el.layoutType === 'video') {
        return null

      } else if (el.layoutType === 'portrait') {
        const portraitImages = [
          {
            key: `${idx}_primary`,
            src: el.portraitImage?.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
            className: 'property-single__lightbox-image',
          },
          {
            key: `${idx}_secondary`,
            src: el.portraitImageSecondary?.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
            className: 'property-single__lightbox-image',
          },
        ];
        return portraitImages;
      }

    }).flat().filter((image) => image !== null)


    return (
      <>
        <Seo bodyClass='post-template project' {...wpProject.seo} />

 
            {passProtected === 'disable' || showContent ? (
              <>

              <article>
                <div className='project__header'>

                  {wpProject.acf.mobileFallbackImage ? (
                    <>
                    <div className='project__header--image desktop'>
                      <GatsbyImage className='section__landscape' loading='lazy' image={getImage(wpProject.acf.landscapeFeaturedImage?.localFile)} alt={wpProject.title} />
                    </div>
                    
                    <div className='project__header--image mobile'>
                      <GatsbyImage className='section__landscape' loading='lazy' image={getImage(wpProject.acf.mobileFallbackImage?.localFile)} alt={wpProject.title} />
                    </div>
                    </>
                  ) : (
                    <div className='project__header--image'>
                      <GatsbyImage className='section__landscape' loading='lazy' image={getImage(wpProject.acf.landscapeFeaturedImage?.localFile)} alt={wpProject.title} />
                    </div>
                  )}
                  
                </div>


                <div className='project__inner'>
                  <div className='project__col'>
                    <h1>{wpProject.title}</h1>

                    <div className='project__subtitle-container'>
                      { wpProject.acf.developer &&
                        <h2 className='subtitle'>
                          {parse(wpProject.acf.developer)}
                        </h2> 
                      }

                      { wpProject.acf.location &&
                        <h2 className='subtitle'>
                          {parse(wpProject.acf.location)}
                        </h2>
                      }
                    </div>

                    {wpProject.acf.description &&
                      <div className='project__description'>
                        { parse(wpProject.acf.description) }
                      </div>
                    }

                    { wpProject.acf.press && wpProject.acf.press.length > 0 &&
                      <>
                        <div className='project__links'>
                          <h3>Press</h3>
                            <ul className='project__links--list'>
                            {wpProject.acf.press && wpProject.acf.press.map((el, i) => {
                              return (
                                  el.pressLink ? (
                                    <li>
                                      {/* <span> */}
                                        <Link to={el.pressLink}>
                                          {parse(el.pressTitle)}
                                        </Link>
                                      {/* </span> */}
                                    </li>
                                  ) : (
                                  <li>
                                    {/* <span> */}
                                      { parse(el.pressTitle) }
                                    {/* </span> */}
                                  </li>
                                  )
                              )
                            })}
                          </ul>
                        </div>
                      </>
                    }

                    
                      <span className='view-slideshow desktop' onClick={() => this.setState({ imageLightbox: !imageLightbox })}>
                        View Slideshow
                      </span>

                  </div>

                  <div className='project__col'>
                    <div className='project__quote'>
                      { wpProject.acf.quote &&
                          parse(wpProject.acf.quote)
                      }
                    </div>

                    <span className='view-slideshow mobile' onClick={() => this.setState({ imageLightbox: !imageLightbox })}>
                        View Slideshow
                      </span>
                    
                    
                          <div
                          className={`project__next-project ${showNextProject ? 'fade-in' : ''}`}
                        >
                    
                        <div className='project__next-project--inner'>
                          <span className={`prev-btn__inner`}>
                            <Link className='prev-btn' to={`/portfolio/${prev.slug}`}>
                              <div className='prev-btn__container'>
                                <span><Arrow color={'#1D1D1B'} /></span>
                                <span className='prev'>Previous Project</span>
                              </div>
                            </Link>
                          </span>

                          <span className={`next-btn__inner`}>
                            <Link className='next-btn' to={`/portfolio/${next.slug}`}>
                              <div className='next-btn__container'>
                                <span><Arrow color={'#1D1D1B'} /></span>
                                <span className='next'>Next Project</span>
                              </div>
                            </Link>
                          </span>
                        </div>
                      </div>

                    {/* <Fade distance='40px' bottom> */}
                      
                    {/* </Fade> */}

                  </div>
                </div>

              </article>
                    


              {/* { console.log(wpProject.acf.gallery) } */}

{/* 
                <FsLightbox
                  toggler={imageLightbox}
                  sources={wpProject.acf.gallery.map((el, idx) => {
                    if (el.layoutType === 'landscape') {
                      return (
                        <img
                          key={idx}
                          src={el.landscapeImage?.localFile.childImageSharp.gatsbyImageData.images.fallback.src}
                          className='property-single__lightbox-image'
                          // alt={wpProperty.seo.title}
                        />
                      );
                    } else if (el.layoutType === 'portrait') {
                      return (
                        <div key={idx}>
                          <img
                            src={el.portraitImage?.localFile.childImageSharp.gatsbyImageData.images.fallback.src}
                            className='property-single__lightbox-image'
                            // alt={wpProperty.seo.title}
                          />
                          <img
                            src={el.portraitImageSecondary?.localFile.childImageSharp.gatsbyImageData.images.fallback.src}
                            className='property-single__lightbox-image'
                            // alt={wpProperty.seo.title}
                          />
                        </div>
                      );
                    }
                  
                  })}
                /> */}


              {/* {wpProject.acf.gallery && 
                <FsLightbox
                  toggler={imageLightbox}
                  sources={wpProject.acf.gallery?.map((el, idx) => (
                    <img
                      key={idx}
                      src={el.landscapeImage?.localFile.childImageSharp.gatsbyImageData.images.fallback.src}
                      className='property-single__lightbox-image'
                    />
                  ))}
                />
              } */}
              
              {/* { console.log(images) } */}

              {images && (
                <FsLightbox
                  // hideFullscreen={true}
                  toggler={imageLightbox}
                  sources={images.map((image, idx) => (
                    <img
                      key={idx} // Ensure a unique key
                      src={image?.src}
                      // className={image?.className}
                    />
                  ))}
                />
              )}



              <div className='list-view'>


                { wpProject.acf.gallery && wpProject.acf.gallery.map((el, i) => {
                  if (el.layoutType === 'landscape') {
                    return (
                      <div className='list-view__inner'>
                        <GatsbyImage className='landscape' loading='lazy' image={getImage(el.landscapeImage?.localFile)} alt={el.title} />
                      </div>
                    )

                  } else if(el.layoutType === 'portrait') {
                    return (
                      <div className='list-view__inner'>
                        <div className='list-view__portrait'>
                          <div className='col'>
                            <GatsbyImage className='portrait' loading='lazy' image={getImage(el.portraitImage?.localFile)} alt={el.title} />
                          </div>

                          <div className='col'>
                            <GatsbyImage className='portrait' loading='lazy' image={getImage(el.portraitImageSecondary?.localFile)} alt={el.title} />
                          </div>
                        </div>
                      </div>
                    )

                  } else if(el.layoutType === 'video') {
                    return (
                      <>
                      <div className='list-view__video'>
                        <Vimeo
                          video={el.vimeoEmbed}
                          autoplay
                          controls={true}
                          showByline={false}
                          loop={true}
                          showPortrait={false}
                          showTitle={false}
                          color='#1D1D1B'
                          background={true}
                        />
                      </div>
                      </>
                    )
                  } else {
                    return (
                      // <div key={i} className='slider__item'>
                      //   <div className={`slider__inner ${this.state.isSliderLoaded ? 'loaded' : ''}`} style={slideStyle}>
                      //     {/* <div className={'slider-fullwidth__meta'}>
                      //       {el.title && <h2 className='project-details__title'>{el.title}</h2>}

                      //       {el.urlLink &&
                      //         <Link className='slider-fullwidth__link' to={el.urlLink}>Read more</Link>
                      //       }
                      //     </div> */}

                      //     <div className='slider-fullwidth__portraits'>
                      //       <div className='col'>
                      //         <GatsbyImage className='portrait' loading='lazy' image={getImage(el.portraitImage?.localFile)} alt={el.title} />
                      //       </div>

                      //       <div className='col'>
                      //         <GatsbyImage className='portrait' loading='lazy' image={getImage(el.portraitImageSecondary?.localFile)} alt={el.title} />
                      //       </div>
                      //     </div>
                      //   </div>
                      // </div>
                      <>
                      
                      </>
                    )
                  }
                  }) }
                      
              </div>
</>

          ) : (
            // Username and Password input form
            <div className='protected'>
              <div className='protected__inner'>
                <h3>This Project is Protected</h3>
                <form onSubmit={this.handleSubmit}>
                
                <div className='protected__form-inner'>
                  <label>
                    Username:
                    <input
                      type="text"
                      name="username"
                      placeholder="Name Entry"
                      value={username}
                      onChange={this.handleInputChange}
                    />
                  </label>
                  <label>
                    Password:
                    <input
                      type="password"
                      name="password"
                      placeholder="Email Entry"
                      value={password}
                      onChange={this.handleInputChange}
                    />
                  </label>
                  <div className='protected__footer'>
                    <div className='btn-container'>
                      <button type="submit">Submit</button>
                    </div>

                    {showMessage && <div className='protected__message'><p>Incorrect username or password. Please try again.</p></div>}
                  </div>
                </div>

                </form>
              </div>

              <div className='protected__arrows'>

              <div className='next-project--inner'>
                          <span className={`prev-btn__inner`}>
                            <Link className='prev-btn' to={`/portfolio/${prev.slug}`}>
                              <div className='prev-btn__container'>
                                <span><Arrow color={'#1D1D1B'} /></span>
                                <span className='prev'>Previous Project</span>
                              </div>
                            </Link>
                          </span>

                          <span className={`next-btn__inner`}>
                            <Link className='next-btn' to={`/portfolio/${next.slug}`}>
                              <div className='next-btn__container'>
                                <span><Arrow color={'#1D1D1B'} /></span>
                                <span className='next'>Next Project</span>
                              </div>
                            </Link>
                          </span>
                        </div>

                      </div>

            </div>
          )}
      </>
    )
  }
}

export const postQuery = graphql`
  query ($id: String!) {
    wpProject(id: { eq: $id }) {
      title
      uri
      seo {
        ...WpSeo
      }
      date(formatString: "MMMM D, YYYY")
      acf {
        landscapeFeaturedImage {
          altText
          localFile {
            childImageSharp {
              gatsbyImageData(width: 2560)
            }
          }
        }
        mobileFallbackImage {
          altText
          localFile {
            childImageSharp {
              gatsbyImageData(width: 2560)
            }
          }
        }
        passwordProtected
        fieldGroupName
        developer
        quote
        location
        description
        press {
          pressLink
          pressTitle
        }
        gallery {
          layoutType
          vimeoEmbed
          landscapeImage {
            altText
            localFile {
              childImageSharp {
                gatsbyImageData(width: 2560)
              }
            }
          }
          portraitImage {
            altText
            localFile {
              childImageSharp {
                gatsbyImageData(width: 2560)
              }
            }
          }
          portraitImageSecondary {
            altText
            localFile {
              childImageSharp {
                gatsbyImageData(width: 2560)
              }
            }
          }
        }
      }
    }
    wp {
      siteOptions {
        acf {
          users {
            fieldGroupName
            password
            username
          }
        }
      }
    }
  }
`

export default PostTemplate
